import * as React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormHelperText from '@mui/material/FormHelperText';


type CompanySalaryFormProps = {
  userData: {
    password: string
    confirm_password: string
    first_name: string
    last_name: string
    gender: string
    date_of_birth: string | null
    place_of_birth: string
    nationality: string
    country_residence: string
    employment_title: string
    employment_type: string
    address1: string
    city: string
    state: string
    country: string
    department: string
    token: string | null
    company_id: string | null
  }
  errors: {
    password: string
    confirm_password: string
    first_name: string
    last_name: string
    gender: string
    date_of_birth: string | null
    place_of_birth: string
    nationality: string
    country_residence: string
    employment_title: string
    employment_type: string
    address1: string
    city: string
    state: string
    country: string
  }
  setErrors:(value: any) => void
  setUserData: (value: any) => void
  steps: string[]
  activeStep: number
  setActiveStep:(value: number) => void
};

export default function CompanySalaryForm({
  userData, errors, setErrors, setUserData, steps, activeStep, setActiveStep, 
}: CompanySalaryFormProps) {
  const handleNext = () => {
    if (userData.employment_title.trim() === '') {
      setErrors({ ...errors, employment_title: 'This field required' });
    }else if (userData.employment_title !== '' && userData.employment_title.length > 50  ) {
      setErrors({ ...errors, employment_title: 'Title must be 50 characters or less' });
    } else if (!/^[a-zA-Z ]+$/.test(userData.employment_title)) {
      setErrors({ ...errors, employment_title: 'Should not contain special characters' });
    } else if (userData.employment_type.trim() === '') {
      setErrors({ ...errors, employment_type: 'This field required' });
    } else {
      setActiveStep(activeStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const handleChange = (name: string, value: string) => {
    setErrors({
      ...errors, employment_title: '', employment_type: '',
    });
    setUserData({ ...userData, [name]: value });
  };

  return (
    <>
      <Typography variant='h6' gutterBottom>
        Company Employment Info
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            required
            id='employment_title'
            name='employment_title'
            label='Employment title'
            autoComplete='given-name'
            error={errors.employment_title !== ''}
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            value={userData.employment_title}
            helperText={errors.employment_title !== '' ? errors.employment_title : ''}
          />

        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl sx={{ m: 0, minWidth: '100%' }}>
            <InputLabel id='demo-simple-select-required-label'>Employment type *</InputLabel>
            <Select
              required
              labelId='demo-simple-select-standard-label'
              id='employment_type'
              label='Employment type'
              name='employment_type'
              error={errors.employment_type !== ''}
              onChange={(e) => handleChange(e.target.name, e.target.value)}
              value={userData.employment_type}
            >
              <MenuItem value=''>
                <em>None</em>
              </MenuItem>
              <MenuItem value='SALARIED'>SALARIED</MenuItem>
              <MenuItem value='SELF_EMPLOYED'>SELF EMPLOYED</MenuItem>
              <MenuItem value='RETIRED'>RETIRED</MenuItem>
              <MenuItem value='NOT_EMPLOYED'>NOT EMPLOYED</MenuItem>
              <MenuItem value='BUSINESS_OWNER'>BUSINESS OWNER</MenuItem>
              <MenuItem value='STUDENT'>STUDENT</MenuItem>
              <MenuItem value='HOMEMAKER'>HOMEMAKER</MenuItem>
              <MenuItem value='OTHER'>OTHER</MenuItem>
            </Select>
            <FormHelperText>{errors.employment_type !== '' ? errors.employment_type : '' }</FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
      {activeStep === steps.length ? (
        <Typography variant='h5' gutterBottom>
              Thank you for your submission.
        </Typography>
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          {activeStep !== 0 && (
            <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
                  Back
            </Button>
          )}

          <Button
            name='next'
            variant='contained'
            onClick={handleNext}
            sx={{ mt: 3, ml: 1 }}
          >
            {activeStep === steps.length - 1 ? 'Update' : 'Next'}
          </Button>
        </Box>
      )}
    </>

  );
}
